// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"d336e091","253":"67c574e0","340":"c81a1216","626":"6426e339","660":"21cd4a67","787":"45b4456f","816":"e8ad3113"}[chunkId] + ".chunk.js";
};